<dx-drop-down-box
  #partitionDropDown
  (onValueChanged)="selectedPartitionChange.emit($event.value);"
  [(value)]="selectedPartition"
  [dataSource]="dashboardService.partitions"
  [disabled]="disabled"
  [displayExpr]="'name'"
  [dropDownOptions]="{
            wrapperAttr:{ class: 'partitionDropdown'}
          }"
  [label]="translate.instant('CHART_CREATION.SELECT_PARTITION')"
  [placeholder]="translate.instant('CHART_CREATION.SELECT_PARTITION')"
  [valueExpr]="'id'"
  labelMode="hidden">
  <div *dxTemplate="let data of 'content'">
    <dx-tree-list
      (onSelectionChanged)="selectedPartition = $event.selectedRowKeys[0]; !!selectedPartition? partitionDropDown.instance.close() : ''"
      [autoExpandAll]="true"
      [columnAutoWidth]="true"
      [columns]="['name']"
      [dataSource]="dashboardService.partitions"
      [height]="'100%'"
      [parentIdExpr]="'parentId'"
      [rootValue]="0"
      [selectedRowKeys]="[selectedPartition]"
      [showBorders]="false"
      [showColumnHeaders]="false"
      [showRowLines]="false"
      [wordWrapEnabled]="true">
      <dxo-scrolling
        [mode]="'standard'">
      </dxo-scrolling>
      <dxo-search-panel
        [visible]="true">
      </dxo-search-panel>
      <dxo-selection
        [allowSelectAll]="false"
        [mode]="'single'"
        [recursive]="false">
      </dxo-selection>
    </dx-tree-list>
  </div>
</dx-drop-down-box>
